// Importing the contact object from the ../../portfolio file and the Contact.css file for styling.
import { contact } from '../../portfolio'
import './Contact.css'

const Contact = () => {
  if (!contact.email) return null
// The Contact component is defined as an arrow function.
// It checks if an email property exists in the contact object. If it doesn't, the component returns null.
  return (
    <section className='section contact center' id='contact'>
      <h2 className='section__title'>Contact</h2>
      <a href={`mailto:${contact.email}`}>
        <span type='button' className='btn btn--outline'>
          Email me
        </span>
      </a>
    </section>
  )
}

export default Contact
